import { useSelector } from "react-redux";
import logo from "../../../../assets/img/logo.png";
import "./index.scss"
const Logo = () => {
    const sidebarCollapsed = useSelector((state) => {
        return state.switcher.sidebarCollapsed
    });
    return (
        <div className="sidebar-logo-container">
            <img src={logo} className="sidebar-logo" alt="logo" style={{height:sidebarCollapsed?16:32}} />
        </div>
    )
}
export default Logo